// Header
export { Header } from "./Header/Header";
export { HeaderNavigation } from "./Header/HeaderNavigation";

// Footer
export { Footer } from "./Footer/Footer";
export { FooterNavigation } from "./Footer/FooterNavigation";

// Shared
export { SocialNavigation } from "./SocialNavigation";
export { Logo } from "./Logo";
export { PlatformSelector } from "./PlatformSelector";
export { NextSection } from "./NextSection";
export { Loader } from "./Loader";
export { PriceSelector } from "./PriceSelector";
export { Pagination } from "./Pagination";
export { SEO } from "./SEO";



// WEBPACK FOOTER //
// ./src/components/index.js